import { css } from 'lit';

export default css`
  :host {
    display: block;
    width: 100%;
    --private-recognition-compact-preview-padding: 24px 16px 16px;
  }

  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  /*For View Recognition In Message */
  .recognition-compact-preview {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    box-sizing: border-box;
    width: 100%;
    padding: var(--private-recognition-compact-preview-padding);
    background: #ffffff;
    border: 1px solid var(--amityeko-color-gray-7);
    border-radius: var(--amityeko-radius-large);
  }

  amityeko-avatar {
    margin-bottom: 10px;
  }

  amityeko-tg-body-two::part(base) {
    color: var(--amityeko-color-gray-3);
    text-align: center;
  }

  amityeko-button {
    width: 100%;
    margin-top: 10px;
  }
`;
